import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "models-page" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center py-12"
}
const _hoisted_4 = { class: "text-grey-darken-2" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "section-card mb-10" }
const _hoisted_7 = { class: "section-card mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_RadarComparisonChart = _resolveComponent("RadarComparisonChart")!
  const _component_ModelsTable = _resolveComponent("ModelsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-section mb-12" }, [
      _createElementVNode("div", { class: "hero-content text-center" }, [
        _createElementVNode("h1", { class: "hero-title mb-6" }, " Model Performance "),
        _createElementVNode("p", { class: "hero-subtitle mx-auto" }, " Explore how individual AI models perform across principles of humane technology. ")
      ])
    ], -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#5539EC"
          })
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.error), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "section-title mb-4" }, "Principle Comparison", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "section-desc mb-4" }, "Select up to 3 models to compare across all 8 humane technology principles.", -1)),
              _createVNode(_component_RadarComparisonChart, { "all-models": _ctx.rankedModels }, null, 8, ["all-models"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title mb-4" }, "All Models", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "section-desc mb-2" }, "Scores reflect baseline performance by default. Use the toggle to compare across Baseline, Good Persona, and Bad Persona results.", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "section-desc mb-4" }, "Click column headers to sort. Click a model name to view details.", -1)),
              _createVNode(_component_ModelsTable, { models: _ctx.rankedModels }, null, 8, ["models"])
            ])
          ]))
  ]))
}